export const formatNullNumber = (value: number | null | undefined): string => {
    if (value == null) return '—';
    return String(value);
};

export const formatAbi = (value: number | null | undefined): string => {
    if (value == null) return '—';
    return value.toFixed(2);
};

export const formatTsMonth = (value: number | null | undefined): string => {
    if (value == null) return '—';
    return String(Math.round(value));
};

export const formatPercent = (value: number | null | undefined): string => {
    if (value == null) return '—';
    return `${value}%`;
};

export const formatFairRoi = (value: number | null | undefined): string => {
    if (value == null) return '—';
    return `${Number(value).toFixed(2)}%`;
};

export const formatFractionAsPercent = (value: number | null | undefined): string => {
    if (value == null) return '—';
    const percent = value * 100;
    return Number.isInteger(percent) ? `${percent}%` : `${percent.toFixed(2).replace(/\.?0+$/, '')}%`;
};

export const formatUsd = (value: number | null | undefined, signed = false): string => {
    if (value == null) return '—';
    const formatted = Math.abs(value).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    if (!signed) return `$${formatted}`;
    if (value === 0) return '$0.00';
    const sign = value > 0 ? '+' : '-';
    return `${sign}$${formatted}`;
};

export const formatYesNo = (value: boolean): string => (value ? 'да' : 'нет');

// Доля выплат игроку: Share + (100% − Share) × rate. share и rate — доли (0..1), результат — доля.
export const payoutShareFraction = (share: number, rate: number): number => share + (1 - share) * rate;

export const bonusAmountsMismatch = (total: number, paid: number | null | undefined): boolean => {
    if (paid == null) return false;
    return Math.abs(total - paid) > 0.01;
};
